export default __webpack_public_path__ + "static/media/segfy-logo.cb1402e9.png";